module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/c3bad198a6d07ca2d305c341284a7f3b.png";